var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeypadDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyboard/key/back",
    transform: "translate(-17.000000, -7.000000)",
    fill: "#00CBC0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4806858,7 C33.0329705,7 33.4806858,7.44771525 33.4806858,8 L33.4806858,18 C33.4806858,18.5522847 33.0329705,19 32.4806858,19 L21.9465061,19 C21.6532343,18.9998658 21.3748042,18.8710007 21.1838506,18.6484091 C18.3946169,15.3368786 17,13.4540756 17,13 C17,12.5459244 18.3946169,10.6631214 21.1838506,7.35159088 C21.3748042,7.12899933 21.6532343,7.00013423 21.9465061,7 L32.4806858,7 Z M31.2838116,9.19687362 C31.021291,8.93437546 30.5956661,8.93437546 30.3328496,9.19687362 L30.3328496,9.19687362 L27.4806858,12.0493597 L24.6285177,9.19687362 L24.56508,9.1409359 C24.3013114,8.93593546 23.9200546,8.9546875 23.6775581,9.19687362 C23.4150616,9.45939418 23.4150616,9.8850191 23.6775581,10.1478357 L23.6775581,10.1478357 L26.5300441,13 L23.6775581,15.8521679 L23.6216204,15.9156056 C23.4166216,16.1793742 23.4353737,16.5606311 23.6775581,16.8031276 C23.9400787,17.0656241 24.3657036,17.0656241 24.6285201,16.8031276 L24.6285201,16.8031276 L27.4806858,13.9506414 L30.332852,16.8031276 L30.3962897,16.8590653 C30.6600583,17.0640641 31.0413151,17.0453121 31.2838116,16.8031276 C31.5463105,16.540607 31.5463105,16.114982 31.2838116,15.8521655 L31.2838116,15.8521655 L28.4313256,13 L31.2838116,10.1478333 L31.3397493,10.0843955 C31.5447505,9.82062696 31.5259985,9.43937014 31.2838116,9.19687362 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadDelete);
export default ForwardRef;